import { scheduleAsyncIterable } from "./scheduleAsyncIterable";
import { readableStreamLikeToAsyncGenerator } from "../util/isReadableStreamLike";
export function scheduleReadableStreamLike(input, scheduler) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
}